import { HttpErrorResponse } from '@angular/common/http';

export class CaseDetailsActionResult {
  constructor(public actionType: ActionType, public httpErrorResponse: HttpErrorResponse | null, public isSuccess: boolean) {}
}

export enum ActionType {
  UpdateCaseDetails = 'UpdateCaseDetails',
  AddFolder = 'AddFolder',
}
